import classNames from 'classnames';
import React, { FC, MouseEventHandler, PropsWithChildren } from 'react';

import { IconView } from '../IconView/IconView';
import { Loader } from '../Loader/Loader';
import styles from './Button.styles.m.css';
import { buttonIconSizeMap, ButtonTypes, IButton } from './Button.types';

export { ButtonTypes };

interface IButtonProps extends IButton<HTMLButtonElement> {
  form?: string;
  type?: ButtonTypes;
  iconClassName?: string;
  isActive?: boolean;
}

export const Button: FC<PropsWithChildren<IButtonProps>> = (props) => {
  const {
    Icon,
    form,
    setRef,
    onClick,
    onContextMenu,
    tabIndex,
    dataTest,
    children,
    className,
    theme = 'primary',
    rounding = '0',
    isLoading = false,
    isDisabled = false,
    size = '10',
    type = ButtonTypes.Button,
    iconClassName,
    id,
    isActive = false,
  } = props;

  const containerClasses = classNames(
    styles.container,
    styles[`size-${size}`],
    styles[`rounding-${rounding}`],
    styles[`theme-${theme}`],
    className,
    { [styles.active]: isActive }
  );

  const handleMouseDown: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
  };

  return (
    <button
      id={id}
      type={type}
      form={form}
      ref={setRef}
      className={containerClasses}
      onClick={onClick}
      onContextMenu={onContextMenu}
      disabled={isDisabled || isLoading}
      tabIndex={tabIndex}
      data-test={dataTest}
      onMouseDown={handleMouseDown}
    >
      <span className={classNames(styles.content, { [styles.hidden]: isLoading })}>
        {Icon && (
          <IconView
            Icon={Icon}
            size={buttonIconSizeMap[size]}
            className={classNames(styles.icon, iconClassName)}
          />
        )}
        <span className={styles.text}>{children}</span>
      </span>
      {isLoading && <Loader className={styles.loader} />}
    </button>
  );
};
